let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iIOOF")).then(() => parcelRequire('3S6lr'));